import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// The receipt endpoint needs the login token, which a plain <a href> cannot send.
// Fetch it with the token and open the file in a new tab instead.
export const openCommissionReceipt = async (commissionId, token) => {
  const tab = window.open('', '_blank'); // open synchronously so pop-up blockers allow it
  try {
    const res = await axios.get(`${API_URL}/api/partner-commissions/${commissionId}/screenshot`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob'
    });
    const url = URL.createObjectURL(res.data);
    if (tab) tab.location.href = url; else window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    if (tab) tab.close();
    alert('Could not open the receipt. Please try again.');
  }
};
